export default function CheckmarkCircleIcon({ width = 16, height = 16, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='8' cy='8' r='8' fill='#1283DA' />
      <path
        d='M10.9343 5.18557L6.73034 9.38952L5.19853 7.85771C5.07254 7.73602 4.90379 7.66869 4.72864 7.67021C4.55348 7.67173 4.38593 7.74199 4.26207 7.86585C4.13821 7.98971 4.06795 8.15726 4.06643 8.33242C4.06491 8.50757 4.13224 8.67632 4.25393 8.80231L6.25804 10.8064C6.38331 10.9317 6.5532 11.002 6.73034 11.002C6.90748 11.002 7.07736 10.9317 7.20264 10.8064L11.8789 6.13017C12.0006 6.00418 12.0679 5.83543 12.0664 5.66028C12.0649 5.48512 11.9946 5.31757 11.8707 5.19371C11.7469 5.06985 11.5793 4.99959 11.4042 4.99807C11.229 4.99655 11.0603 5.06388 10.9343 5.18557Z'
        fill='white'
      />
    </svg>
  );
}
